// store/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    user: null,
    token: null,
};



const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLogin(state, action) {

            state.isAuthenticated = true;
            state.user = action.payload;

        },
        logout(state) {

            state.isAuthenticated = false;
            state.user = null;
            state.token = null;

        },
        loadFromStorage(state, action: any) {
            
            state.user = action.payload;
            state.isAuthenticated = true;
        },

        setRegister(state, action) {
            state.isAuthenticated = true;
            state.user = action.payload;
        },

        setCustomerData(state, action) {

            state.isAuthenticated = true;
            state.user = action.payload;
        }
    },
});

export const { setLogin, logout, loadFromStorage, setRegister, setCustomerData } = authSlice.actions;
export default authSlice.reducer;
